module.exports = __webpack_public_path__ + "img/apidays-2.35c8efaf.png";